import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Toaster } from '../ui/sonner';

const MainLayout = () => {
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <main className="ml-64 min-h-screen p-6 md:p-8" data-testid="main-content">
        <Outlet />
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default MainLayout;
